import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trending-post-card',
  templateUrl: './trending-post-card.component.html',
  styleUrls: ['./trending-post-card.component.css'],
})
export class TrendingPostCardComponent {
  @Input() displayName = '';
  @Input() handle = '';
  @Input() avatarUrl = '';
  @Input() content = '';
  @Input() likes = 0;
  @Input() reposts = 0;
  @Input() comments = 0;
  @Input() tag = '';
  @Input() delayMs = 0;
}
